import { VueSlideToggle } from 'vue-slide-toggle'
import { isClickableInSidebarMenu, isProcessableItem, routeForMenuItem } from '@/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'burger-nav',
  components: {
    VueSlideToggle,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  created() {},
  data() {
    return {
      open: false,
      openSubMenu: false,
    }
  },
  computed: {
    ...mapGetters({
      salesHeaderMenu: 'setting/salesHeaderMenu',
    }),
  },
  methods: {
    isClickableInSidebarMenu: isClickableInSidebarMenu,
    isProcessableItem: isProcessableItem,
    /**
     * @param {NavigationItem} navItem
     * @param {NavigationItem|null} parentNavItem
     * @return {Object}
     */
    routeForMenuItem(navItem, parentNavItem = null) {
      if (navItem.slug === "outlet") {
        return this.$localize({ name: "products", query: { categories: 'outlet' } });
      }
      return this.$localize(routeForMenuItem(navItem, parentNavItem))
    },
  },
}
